export default __webpack_public_path__ + "static/media/loading.153c55e3.gif";